import React from 'react';
import {
  CContainer,
  CHeader,
  CHeaderBrand,
  CHeaderNav,
  CDropdown,
  CDropdownToggle,
  CDropdownMenu,
  CDropdownItem,
  CAvatar,
} from '@coreui/react';
import CIcon from '@coreui/icons-react';
import { cilLockLocked } from '@coreui/icons';
import { useHistory } from 'react-router-dom';

import './AppSidebar.scss';

const AppHeader = ({ content }) => {
  const history = useHistory();

  const handleLockAccount = () => {
    localStorage.removeItem('userId');
    localStorage.removeItem('userId');
    history.push('/login');
  };

  const title = ['System User', 'Import Data', 'Password'];
  return (
    <CHeader style={{ borderRadius: '10px' }}>
      <CContainer fluid>
        <CHeaderBrand href="#">{title[content]}</CHeaderBrand>
        <CHeaderNav className="ms-auto">
          <CDropdown variant="nav-item">
            <CDropdownToggle
              placement="bottom-end"
              className="py-0 pe-0"
              caret={false}
            >
              <CAvatar
                src="https://static.vecteezy.com/system/resources/previews/006/487/917/non_2x/man-avatar-icon-free-vector.jpg"
                size="md"
              />
            </CDropdownToggle>
            <CDropdownMenu className="pt-2" placement="bottom-end">
              <CDropdownItem href="#" onClick={handleLockAccount}>
                <CIcon icon={cilLockLocked} className="me-2" />
                Log Out
              </CDropdownItem>
            </CDropdownMenu>
          </CDropdown>
        </CHeaderNav>
      </CContainer>
    </CHeader>
  );
};

export default AppHeader;
